export default{
    data:()=>({
        digitalFramework: process.env.REACT_APP_BaseUrlDigitalFramework //"https://localhost:7256" , "https://localhost:7120"
    }),
    computed:{}
};